"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Grid2 = _interopRequireDefault(require("@material-ui/core/Grid"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["children", "className"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Grid = /*#__PURE__*/(0, _react.forwardRef)(function Grid(props, ref) {
  var children = props.children,
      className = props.className,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Grid2.default, Object.assign({}, rest, {
    className: className,
    ref: ref
  }), children);
});
Grid.propTypes = {
  /**
   * Defines the align-content style property. It's applied for all screen sizes.
   */
  alignContent: (0, _propTypes.oneOf)(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),

  /**
   * Defines the align-items style property. It's applied for all screen sizes.
   */
  alignItems: (0, _propTypes.oneOf)(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),

  /**
   * The content of the component.
   */
  children: _propTypes.node,

  /**
   * Applies additional CSS classes to the wrapper of the `Checkbox` component.
   */
  className: _propTypes.string,

  /**
   * The component used for the root node. Either a string to use a DOM element or a component.
   */
  component: _propTypes.elementType,

  /**
   * If true, the component will have the flex container behavior. You should be wrapping items with a container.
   */
  container: _propTypes.bool,

  /**
   * Defines the flex-direction style property. It is applied for all screen sizes.
   */
  direction: (0, _propTypes.oneOf)(['row', 'row-reverse', 'column', 'column-reverse']),

  /**
   * If true, the component will have the flex item behavior. You should be wrapping items with a container.
   */
  item: _propTypes.bool,

  /**
   * Defines the justify-content style property. It is applied for all screen sizes.
   */
  justifyContent: (0, _propTypes.oneOf)(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),

  /**
   * Defines the number of grids the component is going to use. It's applied for the lg breakpoint and wider screens if not overridden.
   */
  lg: (0, _propTypes.oneOf)([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use. It's applied for the md breakpoint and wider screens if not overridden.
   */
  md: (0, _propTypes.oneOf)([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use. It's applied for the sm breakpoint and wider screens if not overridden.
   */
  sm: (0, _propTypes.oneOf)([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the flex-wrap style property. It's applied for all screen sizes.
   */
  wrap: (0, _propTypes.oneOf)(['nowrap', 'wrap', 'wrap-reverse']),

  /**
   * Defines the number of grids the component is going to use. It's applied for the xl breakpoint and wider screens.
   */
  xl: (0, _propTypes.oneOf)([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use. It's applied for all the screen sizes with the lowest priority.
   */
  xs: (0, _propTypes.oneOf)([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * If true, it sets min-width: 0 on the item. Refer to the limitations section of the documentation to better understand the use case.
   */
  zeroMinWidth: _propTypes.bool
};
var _default = Grid;
exports.default = _default;
